<template>
  <div class="header-container">
    <div v-show="!isDesMobile" class="shadow padding-top-bottom-20">
      <div>
        <el-row type="flex" justify="center" style="height: 50px;">
          <el-col :span="16" class="header">
            <el-col :span="24">
              <el-row type="flex">
                <el-col :span="8">
                  <div class="logoWrapper"  style="width: auto; height: 60px;margin: 8px 0px ;cursor: pointer;" >
                    <img :src="activity&&activity.logoUrl" alt  style="max-width:100%;max-height:100%;"/>
                    <span v-if="lang=='zh'" class="padding-left-20 pointer" @click="go2IndexHome">{{activity&&activity.name}}</span>
                    <span v-if="lang=='en'" class="padding-left-20 pointer" @click="go2IndexHome">{{activity&&activity.nameEn}}</span>
                  </div>
                </el-col>
                <el-col :span="8" class="tell server-phone">
                  {{$t('lang.客服电话')}}：{{activity&&activity.hotLine||activity&&activity.hot_line}}
                </el-col>

                <el-col :span="8" class="login">
                  <template v-if="loginShow">
                    <div class="text-center">
                      <span style="margin-right:10px;" class="text-one-row-overflow text-center" v-if="currentUser">{{usernName}}</span>
                      <el-button class="login-btn text-center" type="text" @click="loginout">
                        {{$t('lang.退出登录')}}
                      </el-button>
                    </div>
                  </template>
                  <template v-if="src=='0'">
                    <div style="margin-left:15px;">
                      <el-button class="login-btn" type="text" @click="changePassword">
                        {{$t('lang.修改密码')}}
                      </el-button>
                    </div>
                  </template>
                  <template v-if="!loginShow">
                    <div style="margin-left:15px;">
                      <el-button class="login-btn" @click="login" type="text">{{$t('lang.登录')}}
                      </el-button>
                    </div>
                  </template>

                  <el-button class="login-btn padding-left-20" v-if="lang=='zh'" @click="switchLanguage('en')" type="text">
                    <span class="color-primary">中</span>/EN
                  </el-button>
                  <el-button class="login-btn padding-left-20" v-if="lang=='en'" @click="switchLanguage('zh')" type="text">
                    <span class="color-primary">EN</span>/中
                  </el-button>
                </el-col>
              </el-row>
            </el-col>
          </el-col>
        </el-row>
      </div>
    </div>
    <div v-show="isDesMobile" class="m-header-container">
      <div class="height-site"></div>
      <div class="m-header">
        <i class="el-icon-arrow-left back" @click="goback" v-show="mBackShow"></i>
        <div class="title">{{titleWrapper}}</div>
      </div>
    </div>

    <!-- 登录弹窗 -->
    <loginCommon :visible.sync="loginVisible"></loginCommon>

    <!-- 修改密码弹窗 -->
    <passwordCommon :visible.sync="passwordVisible"></passwordCommon>
  </div>
</template>
<script>
import { createProp } from "@common/utils";
import loginCommon from "@match/components/login/loginDialog";
import passwordCommon from "@match/components/password/password";
import myalert from "@common/utils/myalert";
import { jsonParseSafe } from "@common/utils";
import messageStoreMixin from "@match/store/message/messageStoreMixin";
import { loginIM } from "../login/loginIM";
import { queryActivity, getMeetingStatistics } from "@common/api";
import { type_src_supplier } from "@common/constact.js";
import { goBack, push } from "@common/utils/routerUtil";
import { gobackYiWu } from "@common/utils";
import { mapGetters } from "vuex";
import { getProjectId } from "@common/utils";
import { getCookie, setCookie } from "@common/utils";
import { getNickName } from "@common/utils";
import { getLoginUser } from "@common/utils";
import { params2url } from "@common/utils";
import { activityDetail, getUserName,isLogin } from "@common/utils";
import {userLogout} from "../../../common/api";



export default {
  "name": "navHeader",
  mixins: [messageStoreMixin],
  data() {
    return {
      loginShow: false,
      passwordVisible: false,
      lang: sessionStorage.getItem("lang") || 'zh',
      activity: {},
      projectId: '',
      src: '',
      statistics: {},
      loginVisible: false,
      titleWrapper: "",
    }
  },
  computed: {
    ...mapGetters("mobile", [
      "isDesMobile"
    ]),
    usernName() {
      return getUserName()
    },
    isLogin(){
      return isLogin()
    }
  },
  props: {
    mBackShow: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: ""
    },
    value: createProp(String)
  },
  created() {
    const currentUser = getLoginUser()
    this.src = currentUser.user2src
    this.set_currentUser(currentUser) //刷新界面 重新session user得到数据
  },
  mounted() {
    this.projectId = sessionStorage.getItem('projectId')
    const currentUser = getLoginUser()
    this.loginShow = currentUser && currentUser.id ? true : false;
    this.ajaxTitleWrapper();
    setTimeout(() => {
      this.activityDetail()
      this.getStatistics()
    }, 1000)
  },
  methods: {
    async ajaxTitleWrapper() {
      var activity = await activityDetail()
      // console.log("activity,this.title===>", this.lang, this.title, activity, activity[this.lang == 'en' ? 'nameEn' : 'name'])
      this.titleWrapper = this.title || activity && activity[this.lang == 'en' ? 'nameEn' : 'name']
    },
    goback() {
       console.log('----', history, this.$router.go(-1))
      if (history.length <= 2) {
        gobackYiWu()
        return false
      } else {
        this.$router.go(-1)
      }
    },
    getNickName() {
      return getNickName()
    },
    async activityDetail() {
      this.activity = await activityDetail();
      if (this.lang == 'zh') {
        document.title = this.activity.name
      } else {
        document.title = this.activity.nameEn
      }
    },
    getStatistics() {
      let params = {
        projectId: sessionStorage.getItem('projectId') || getProjectId()
      }
      getMeetingStatistics(params).then(res => {
        // res && (this.statistics = res.result)
        var today = res.result
        today.num = today.audienceNumber + today.supplierNumber
        this.statistics = today
      })
    },
    go2IndexByUserType() {
      var user = getLoginUser()
      var projectId = this.$route.query.projectId
      this.src = user.user2src
      if (user.user2src === type_src_supplier) {
        this.$router.push(`/user/yiwu/exhibition/index?projectId=${projectId}`)
        return false
      } else {
        this.$router.push(`/user/yiwu/purchaser/index?projectId=${projectId}`)
        return false
      }
    },
    /*退出登陆*/
    async loginout() {
      var user = getLoginUser()
      var projectId = user.projectId
      var isyes = await myalert.confirm(this.$t('lang.确定要注销吗'))
      if (!isyes) {
        return false
      }
      setCookie("user2", "")
      setCookie("matchCgsType", "")
      sessionStorage.setItem('page1', 1);
      sessionStorage.setItem('page2', 1);
      myalert.success(this.$t('lang.注销成功，界面即将刷新'))
      /*消息退出登陆*/
      userLogout()
      window.tim && window.tim.logout && window.tim.logout()
      setTimeout(() => {
        location.href = `/font/toLogin?projectId=${projectId}`
      }, 1000)
    },
    async go2Index() {
      var user = getLoginUser()
      console.log(type_src_supplier)
      if (user.user2src == type_src_supplier) {
        push(`/user/yiwu/exhibition/index`)
        return false
      } else {
        push(`/user/yiwu/purchaser/index`)
        return false
      }
    },
    go2IndexHome() {
      push(`/font/toLogin`)
      return false
    },
    // 显示登录弹窗
    login() {
      this.openLoginDialog()
    },
    openLoginDialog() {
      this.loginVisible = true
      // this.$emit('update:loginVisible', true)
    },
    closeLoginDialog() {
      this.loginVisible = false
      // this.$emit('update:loginVisible', false)
    },
    //显示修改密码弹窗
    changePassword() {
      this.passwordVisible = !this.passwordVisible
    },
    // 中英文切换
    async switchLanguage(type) {
      var isyes = await myalert.confirm(this.$t('lang.确定要切换语言吗？'))
      if (!isyes) return false
      this.lang = type
      this.$i18n.locale = type
      sessionStorage.setItem('lang', type)
      sessionStorage.setItem("matchCgsType", "")
      var url = location.pathname
      location.href = `${url}?${params2url({
        projectId: getProjectId(),
        lang: type
      })}`
    },
  },
  components: {
    loginCommon,
    passwordCommon
  },

}
</script>
<style lang="less" scoped>
.online {
  width: 66.66667%;
  margin: 0 auto;
  color: #666666;
  font-size: 12px;

  .people {
    float: right;
  }
}

.clearfix:after {
  content: '';
  display: block;
  height: 0;
  visibility: hidden;
  clear: both;
}

.header {
  display: flex;
  align-items: center;
}

.logoWrapper {
  display: flex;
  align-items: center;
}

.logoWrapper img {

}

.tell {
  display: flex;
  align-items: center;
  justify-content: center;
}

.login {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .login-btn {
    color: #0f5490;
  }
}

.m-header-container {
  .height-site {
    height: 45px;
    width: 100%;
  }

  .m-header {
    display: flex;
    align-items: center;
    height: 45px;
    justify-content: center;
    position: fixed;
    top: 0;
    background: #fff;
    width: 100%;
    left: 0;
    z-index: 999;
    box-shadow: 0px 4px 9px 0px rgba(221, 223, 225, 0.36);

    i.back {
      position: absolute;
      left: 5%;
      height: 100%;
      display: flex;

      align-items: center;
      font-size: 25px;

      font-weight: bold;
    }

    .title {
      font-weight: bold;
      color: #333;
      font-size: 16px;
    }
  }
}

.padding-left-20 {
  padding-left: 20px;
}

@media screen and (max-width: 769px) {
  .activity-name {
    display: none;
  }

  .server-phone {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/match/components/navHeader/index.vue